import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from "~/utils/api.ts";
import API_URLS from "~/utils/urls.ts";

export interface App {
    public_id: string;
    name: string;
    description: string;
    client_id: string;
}

interface AppsState {
    apps: App[];
    loading: boolean;
    error: string | null;
    app: App | null;
}

const initialState: AppsState = {
    apps: [],
    loading: false,
    error: null,
    app: null
};

export const fetchApps = createAsyncThunk(
    'app/fetchApps',
    async (_, { rejectWithValue }) => {
        try{
            const response = await API.get(
                API_URLS.APPS.GET
            );
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue('Failed to fetch apps');
        }
    }
);


export const fetchApp = createAsyncThunk(
    'app/fetchApp',
    async (public_id: string, { rejectWithValue }) => {
        try {
            const response = await API.get(
                API_URLS.APPS.DETAIL(public_id)
            );
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue('Failed to fetch app');
        }
    }
);

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchApps.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchApps.fulfilled, (state, action) => {
                state.loading = false;
                state.apps = action.payload;
            })
            .addCase(fetchApps.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchApp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchApp.fulfilled, (state, action) => {
                state.loading = false;
                state.app = action.payload;
            })
            .addCase(fetchApp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });

    },
});

export const { clearError } = appSlice.actions;
export default appSlice.reducer;